<template>
  <article class="MyOrdersListItem order-finished my-2">
    <div class="MyOrdersListItem__info-and-status">
      <div class="MyOrdersListItem__info">
        <a :href="'/dashboard/order/' + order.id + '/info' "
           class="MyOrdersListItem__title text-blue-600"
           title="Discipline / Title"
        >
          {{ filterDiscipline(order.discipline) }}
          <span class="MyOrdersListItem__topic capitalize">{{ order.title }}</span>
        </a>
        <div class="MyOrdersListItem__info-description">
          <span class="MyOrdersListItem__info-general">
            <span class="MyOrdersListItem__info-general__item">#{{ order.id }}</span>
            <span class="MyOrdersListItem__info-general__item">{{ order.pages }} page<span
                v-if="order.pages > 1">s</span> </span>
            <span class="MyOrdersListItem__info-general__item">
              {{ filterAcademicLevel(order.academicLevel) }}
            </span>
          </span>
          <div class="MyOrdersListItem__info-deadline">
            Created: <strong>{{ formatDate }}</strong>
          </div>
        </div>
      </div>
      <div class="MyOrdersListItem__status">
        <div class="MyOrdersListItem__status-indication">
          <div class="progress-segments single">
            <div class="relative px-5 py-2 font-medium text-white group">
              <span
                  class="absolute inset-0 w-full h-full transition-all duration-300 ease-out transform translate-x-0 -skew-x-12 bg-blue-500 group-hover:bg-blue-700 group-hover:skew-x-12"></span>
              <span
                  class="absolute inset-0 w-full h-full transition-all duration-300 ease-out transform skew-x-12 bg-blue-700 group-hover:bg-blue-500 group-hover:-skew-x-12"></span>
              <span
                  class="absolute bottom-0 left-0 hidden w-10 h-20 transition-all duration-100 ease-out transform -translate-x-8 translate-y-10 bg-blue-600 -rotate-12"></span>
              <span
                  class="absolute bottom-0 right-0 hidden w-10 h-20 transition-all duration-100 ease-out transform translate-x-10 translate-y-8 bg-blue-400 -rotate-12"></span>
              <span class="relative">{{ order.status }}</span>
            </div>
          </div>
        </div>
        <div class="MyOrdersListItem__status-description">Your order has been {{ order.status.toLowerCase() }}.</div>
      </div>
    </div>
    <div class="MyOrdersListItem__footer">
      <div class="MyOrdersListItem__footer-controls">
        <router-link
            :to="'/dashboard/order/' + order.id + '/info' "
            class="MyOrdersListItem__button MyOrdersListItem__button--messages"
        >
          <span class="MyOrdersListItem__button__text">Messages</span>
        </router-link>
        <router-link
            :to="'/dashboard/order/' + order.id + '/info' "
            class="MyOrdersListItem__button MyOrdersListItem__button--files"
            href="/dashboard/order/292357861/files"
        >
          <span class="MyOrdersListItem__button__text">Files</span>
        </router-link>
      </div>
      <div class="order-footer-cancel-and-cost">
        <button
            class="MyOrdersListItem__button MyOrdersListItem__button--tips UIButton UIButton-default-light UIButton-default-light--size-m UIButton-default-light--color-primary"
            type="button"><span class="MyOrdersListItem__button__text">PayPal Checkout ${{ order.price }}</span>
        </button>
      </div>
    </div>
  </article>
</template>

<script>

import {parseJSON} from 'date-fns';
import format from 'date-fns/format'
import {ACADEMIC_LEVELS, DEADLINES, DISCIPLINES, PAPER_FORMATS, PAPER_TYPES,} from "@/components/order/orderObjects";

export default {
  name: "OrderCard",
  props: ['order'],
  data() {
    return {
      ACADEMIC_LEVELS, DEADLINES, DISCIPLINES, PAPER_FORMATS, PAPER_TYPES,
    }
  },
  computed: {
    formatDate: function () {
      return format(parseJSON(this.order.created), "MMMM d, yyyy HH:mm aaa");
    },
    orderDiscipline: function (id) {
      return this.filterDiscipline(id) || 'Discipline ';
    }
  },
  methods: {
    filterAcademicLevel(id) {
      return this.ACADEMIC_LEVELS.filter(function (item) {
        return item.id === id;
      })[0]['title'];
    },
    filterDiscipline(id) {
      return this.DISCIPLINES.filter(function (discipline) {
        return discipline.id === id;
      })[0]['name'];
    },
  },
}
</script>

<style scoped>

.MyOrdersListItem {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.2);
  margin-bottom: 8px;
  padding: 18px 24px 10px;
  position: relative;
}

.MyOrdersListItem .order-footer-cancel-and-cost {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}

.MyOrdersListItem .MyOrdersListItem__button--cancel {
  margin-right: 10px;
}

.MyOrdersListItem .total-price-and-discount {
  align-items: center;
  display: flex;
  margin: 9px 5px;
  font-weight: 500;
}

.MyOrdersListItem .total-price {
  font-size: 20px;
}

.MyOrdersListItem .total-price--discount {
  color: #69b71a;
}

.MyOrdersListItem .discount {
  font-size: 15px;
  margin-right: 10px;
  vertical-align: middle;
  text-decoration: line-through;
  opacity: 0.7;
}

.MyOrdersListItem__button__new-count {
  background-color: rgba(0, 67, 113, 0.25);
  border-radius: 50%;
  display: inline-block;
  font-size: 11px;
  line-height: 16px;
  min-width: 16px;
  margin-left: 5px;
  padding: 2px;
  text-align: center;
  vertical-align: top;
}

.MyOrdersListItem--with-separator {
  margin-bottom: 40px;
  position: relative;
}

.MyOrdersListItem--with-separator:after {
  border-bottom: 1.5px dashed rgba(0, 0, 0, 0.25);
  bottom: -20px;
  content: "";
  left: -10px;
  position: absolute;
  right: -10px;
}

@media only screen and (min-width: 1025px) {
  .MyOrdersListItem__info-and-status {
    display: flex;
  }
}

.MyOrdersListItem__info {
  color: rgba(0, 0, 0, 0.6);
  flex: 0 0 42%;
  line-height: 18px;
  margin-right: 30px;
  min-width: 0;
}

.MyOrdersListItem__title {
  display: block;
  font-weight: 700;
  line-height: 26px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MyOrdersListItem__topic:before {
  content: " / ";
  opacity: 0.3;
}

.MyOrdersListItem__info-description {
  font-size: 13px;
  margin-bottom: 10px;
}

.MyOrdersListItem__info-general {
  display: block;
  line-height: 150%;
}

@media only screen and (min-width: 641px) {
  .MyOrdersListItem__info-general {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.MyOrdersListItem__info-general__item:not(:last-child):after {
  content: " / ";
  opacity: 0.7;
}

.MyOrdersListItem__info-deadline {
  font-weight: 400;
}

.MyOrdersListItem__status {
  flex: 1 1 auto;
  min-width: 0;
}

.MyOrdersListItem__status-indication {
  align-items: center;
  display: flex;
  margin-bottom: 8px;
}

.MyOrdersListItem__status-description {
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 10px;
}

.MyOrdersListItem__footer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.MyOrdersListItem__footer-controls {
  margin: 5px 0;
}

.MyOrdersListItem__id {
  border-width: 0;
  color: #777;
  font-size: 13px;
  margin-right: 10px;
}

.MyOrdersListItem__id:before {
  content: "#";
  display: inline;
}

.MyOrdersListItem__id:active,
.MyOrdersListItem__id:focus,
.MyOrdersListItem__id:hover {
  color: #0065cc;
}

.MyOrdersListItem__button {
  background-color: #f3f9fd;
  border: 1px solid rgba(74, 90, 182, 0.1);
  border-radius: 3px;
  color: #007eff;
  cursor: pointer;
  font-size: 14px;
  margin: 3px 5px 3px 0;
  padding: 6px 12px;
  font-family: inherit;
  line-height: 120%;
  -webkit-transition: border-color 0.2s;
  transition: border-color 0.2s;
}

.MyOrdersListItem__button:hover {
  border-color: rgba(0, 126, 255, 0.4);
  color: #007eff;
}

.MyOrdersListItem__button:active,
.MyOrdersListItem__button:focus {
  border-color: rgba(74, 90, 182, 0.5);
}

.MyOrdersListItem__button__text {
  display: none;
  margin-left: 5px;
}

@media only screen and (min-width: 641px) {
  .MyOrdersListItem__button__text {
    display: inline-block;
  }
}

.MyOrdersListItem__button--highlight {
  background-color: #2199e8;
  color: #f3f9fd;
}

.MyOrdersListItem__button--highlight:hover {
  background-color: #1984ca;
  color: #fff;
}

.MyOrdersListItem__button--cancel-order:before,
.MyOrdersListItem__button--feedback:before,
.MyOrdersListItem__button--files:before,
.MyOrdersListItem__button--messages:before,
.MyOrdersListItem__button--pay:before,
.MyOrdersListItem__button--reorder:before,
.MyOrdersListItem__button--tips:before,
.MyOrdersListItem__button--unread-messages:before {
  background-color: transparent;
  content: "";
  display: inline-block;
  height: 19px;
  margin-top: -1px;
  vertical-align: middle;
  width: 19px;
}

.MyOrdersListItem__button--cancel-order:hover:before,
.MyOrdersListItem__button--feedback:hover:before,
.MyOrdersListItem__button--files:hover:before,
.MyOrdersListItem__button--messages:hover:before,
.MyOrdersListItem__button--pay:hover:before,
.MyOrdersListItem__button--reorder:hover:before,
.MyOrdersListItem__button--tips:hover:before,
.MyOrdersListItem__button--unread-messages:hover:before {
  opacity: 0.9;
}

.MyOrdersListItem__button--messages:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxMS4wNyI+PHBhdGggZD0iTTEyLjkgMEgyLjFBMi4xIDIuMSAwIDAwMCAyLjFWOWEyLjExIDIuMTEgMCAwMDIuMSAyLjExaDEwLjhBMi4xMSAyLjExIDAgMDAxNSA5VjIuMUEyLjEgMi4xIDAgMDAxMi45IDB6TTEuNSAyLjYxbDQuNjIgNGEyLjEgMi4xIDAgMDAyLjc2IDBsNC42Mi00VjlhLjYuNiAwIDAxLS42LjYxSDIuMUEuNi42IDAgMDExLjUgOXptNi40IDIuODhhLjYuNiAwIDAxLS43OSAwbC00LjYtNGgxMHoiIGZpbGw9IiMwMDdlZmYiIGRhdGEtbmFtZT0iTGF5ZXIgMiIvPjwvc3ZnPg==) 50%/18px 13px no-repeat;
}

.MyOrdersListItem__button--messages.MyOrdersListItem__button--highlight:before {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxMS4wNyI+PHBhdGggZD0iTTEyLjkgMEgyLjFBMi4xIDIuMSAwIDAwMCAyLjFWOWEyLjExIDIuMTEgMCAwMDIuMSAyLjExaDEwLjhBMi4xMSAyLjExIDAgMDAxNSA5VjIuMUEyLjEgMi4xIDAgMDAxMi45IDB6TTEuNSAyLjYxbDQuNjIgNGEyLjEgMi4xIDAgMDAyLjc2IDBsNC42Mi00VjlhLjYuNiAwIDAxLS42LjYxSDIuMUEuNi42IDAgMDExLjUgOXptNi40IDIuODhhLjYuNiAwIDAxLS43OSAwbC00LjYtNGgxMHoiIGZpbGw9IiNmZmYiIGRhdGEtbmFtZT0iTGF5ZXIgMiIvPjwvc3ZnPg==);
}

.MyOrdersListItem__button--files:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxMi41NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDdlZmZ9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzItMiIgZGF0YS1uYW1lPSJMYXllciAyIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNC44MSAzLjQ5YTEuNjYgMS42NiAwIDAwLTEuNjYtMS42NmgtNS45YS41Mi41MiAwIDAxLS4zNC0uMTJMNS40Ny41NmExLjY4IDEuNjggMCAwMC0xLS4zNkgxLjg1QTEuNjUgMS42NSAwIDAwLjIgMS44NXY4Ljg0YTEuNjUgMS42NSAwIDAwMS42NSAxLjY2aDExLjNhMS42NiAxLjY2IDAgMDAxLjY2LTEuNjZ6bS0xLjExIDcuMmEuNTYuNTYgMCAwMS0uNTUuNTZIMS44NWEuNTYuNTYgMCAwMS0uNTUtLjU2VjZoMTIuNHptMC01Ljg0SDEuM3YtM2EuNTUuNTUgMCAwMS41NS0uNTVoMi41OGEuNTUuNTUgMCAwMS4zNS4xMmwxLjQzIDEuMTVhMS42NSAxLjY1IDAgMDAxIC4zN2g1LjlhLjU1LjU1IDAgMDEuNTUuNTV6Ii8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuMTUgMTIuNTVIMS44NUExLjg2IDEuODYgMCAwMTAgMTAuNjlWMS44NUExLjg1IDEuODUgMCAwMTEuODUgMGgyLjU4QTEuOTEgMS45MSAwIDAxNS42LjQxTDcgMS41NmEuMzUuMzUgMCAwMC4yMi4wOGg1LjlBMS44NSAxLjg1IDAgMDExNSAzLjQ5djcuMmExLjg2IDEuODYgMCAwMS0xLjg1IDEuODZ6TTEuODUuMzlBMS40NyAxLjQ3IDAgMDAuMzkgMS44NXY4Ljg0YTEuNDcgMS40NyAwIDAwMS40NiAxLjQ3aDExLjNhMS40NyAxLjQ3IDAgMDAxLjQ2LTEuNDd2LTcuMkExLjQ2IDEuNDYgMCAwMDEzLjE1IDJoLTUuOWEuNzUuNzUgMCAwMS0uNDctLjE3TDUuMzUuNzJhMS40OCAxLjQ4IDAgMDAtLjkyLS4zM3ptMTEuMyAxMUgxLjg1YS43Ni43NiAwIDAxLS43NS0uNzVWNS43N2gxMi44djQuOTJhLjc2Ljc2IDAgMDEtLjc1Ljc1ek0xLjQ5IDYuMTZ2NC41M2EuMzYuMzYgMCAwMC4zNi4zNmgxMS4zYS4zNi4zNiAwIDAwLjM2LS4zNlY2LjE2ek0xMy45IDUuMDVIMS4xdi0zLjJhLjc1Ljc1IDAgMDEuNzUtLjc0aDIuNThhLjc4Ljc4IDAgMDEuNDcuMTZsMS40MyAxLjE1YTEuNDcgMS40NyAwIDAwLjkyLjMyaDUuOWEuNzUuNzUgMCAwMS43NC43NXpNMS40OSA0LjY2aDEyVjMuNDlhLjM2LjM2IDAgMDAtLjM1LS4zNkg3LjI1YTEuODkgMS44OSAwIDAxLTEuMTYtLjQxTDQuNjYgMS41OGEuMzQuMzQgMCAwMC0uMjMtLjA4SDEuODVhLjM2LjM2IDAgMDAtLjM2LjM1eiIvPjwvZz48L2c+PC9zdmc+) top/18px 15px no-repeat;
}

.MyOrdersListItem__button--files.MyOrdersListItem__button--highlight:before {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxMi41NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmZ9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzItMiIgZGF0YS1uYW1lPSJMYXllciAyIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNC44MSAzLjQ5YTEuNjYgMS42NiAwIDAwLTEuNjYtMS42NmgtNS45YS41Mi41MiAwIDAxLS4zNC0uMTJMNS40Ny41NmExLjY4IDEuNjggMCAwMC0xLS4zNkgxLjg1QTEuNjUgMS42NSAwIDAwLjIgMS44NXY4Ljg0YTEuNjUgMS42NSAwIDAwMS42NSAxLjY2aDExLjNhMS42NiAxLjY2IDAgMDAxLjY2LTEuNjZ6bS0xLjExIDcuMmEuNTYuNTYgMCAwMS0uNTUuNTZIMS44NWEuNTYuNTYgMCAwMS0uNTUtLjU2VjZoMTIuNHptMC01Ljg0SDEuM3YtM2EuNTUuNTUgMCAwMS41NS0uNTVoMi41OGEuNTUuNTUgMCAwMS4zNS4xMmwxLjQzIDEuMTVhMS42NSAxLjY1IDAgMDAxIC4zN2g1LjlhLjU1LjU1IDAgMDEuNTUuNTV6Ii8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuMTUgMTIuNTVIMS44NUExLjg2IDEuODYgMCAwMTAgMTAuNjlWMS44NUExLjg1IDEuODUgMCAwMTEuODUgMGgyLjU4QTEuOTEgMS45MSAwIDAxNS42LjQxTDcgMS41NmEuMzUuMzUgMCAwMC4yMi4wOGg1LjlBMS44NSAxLjg1IDAgMDExNSAzLjQ5djcuMmExLjg2IDEuODYgMCAwMS0xLjg1IDEuODZ6TTEuODUuMzlBMS40NyAxLjQ3IDAgMDAuMzkgMS44NXY4Ljg0YTEuNDcgMS40NyAwIDAwMS40NiAxLjQ3aDExLjNhMS40NyAxLjQ3IDAgMDAxLjQ2LTEuNDd2LTcuMkExLjQ2IDEuNDYgMCAwMDEzLjE1IDJoLTUuOWEuNzUuNzUgMCAwMS0uNDctLjE3TDUuMzUuNzJhMS40OCAxLjQ4IDAgMDAtLjkyLS4zM3ptMTEuMyAxMUgxLjg1YS43Ni43NiAwIDAxLS43NS0uNzVWNS43N2gxMi44djQuOTJhLjc2Ljc2IDAgMDEtLjc1Ljc1ek0xLjQ5IDYuMTZ2NC41M2EuMzYuMzYgMCAwMC4zNi4zNmgxMS4zYS4zNi4zNiAwIDAwLjM2LS4zNlY2LjE2ek0xMy45IDUuMDVIMS4xdi0zLjJhLjc1Ljc1IDAgMDEuNzUtLjc0aDIuNThhLjc4Ljc4IDAgMDEuNDcuMTZsMS40MyAxLjE1YTEuNDcgMS40NyAwIDAwLjkyLjMyaDUuOWEuNzUuNzUgMCAwMS43NC43NXpNMS40OSA0LjY2aDEyVjMuNDlhLjM2LjM2IDAgMDAtLjM1LS4zNkg3LjI1YTEuODkgMS44OSAwIDAxLTEuMTYtLjQxTDQuNjYgMS41OGEuMzQuMzQgMCAwMC0uMjMtLjA4SDEuODVhLjM2LjM2IDAgMDAtLjM2LjM1eiIvPjwvZz48L2c+PC9zdmc+);
}

.MyOrdersListItem__button--cancel-order {
  background: #fdf6f6;
  color: #d25445;
  border-color: rgba(210, 84, 69, 0.2);
}

.MyOrdersListItem__button--cancel-order:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMS4xIDExLjEiPjxnIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PHBhdGggZD0iTTYuNzUgNS41NWw0LjEtNC4xYS44My44MyAwIDAwMC0xLjIuODUuODUgMCAwMC0xLjIgMGwtNC4xIDQuMS00LjEtNC4xYS44NS44NSAwIDAwLTEuMiAxLjJsNC4xIDQuMS00LjEgNC4xYS44NS44NSAwIDAwMCAxLjIuODMuODMgMCAwMC42LjI1LjgyLjgyIDAgMDAuNi0uMjVsNC4xLTQuMSA0LjEgNC4xYS44NS44NSAwIDAwLjYuMjUuODIuODIgMCAwMC42LS4yNS44My44MyAwIDAwMC0xLjJ6IiBmaWxsPSIjZDI1NDQ1IiBkYXRhLW5hbWU9IkxheWVyIDMiLz48L2c+PC9zdmc+) 50%/11px 11px no-repeat;
}

.MyOrdersListItem__button--cancel-order:hover {
  border-color: rgba(210, 84, 69, 0.4);
  color: rgba(210, 84, 69, 0.8);
}

.MyOrdersListItem__button--pay:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS4yMyAxNC4yMyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDdlZmZ9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzItMiIgZGF0YS1uYW1lPSJMYXllciAyIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNS4xMSA5Ljc3bC0uMTgtLjN2LS4wNmExLjM3IDEuMzcgMCAwMC4xOS0uNjdWMS40OUExLjU2IDEuNTYgMCAwMDEzLjU2IDBoLTEyQTEuNTIgMS41MiAwIDAwMCAxLjUydjcuMTdhMS41MiAxLjUyIDAgMDAxLjUxIDEuNTJoMi4yOHYuMDhhLjc0Ljc0IDAgMDAuMDcuMzFzMiAzLjYzIDUuNjMgMy42M2MzLjI5IDAgNS4xNy0yLjg3IDUuNTItMy40NWwuMDYtLjFhLjg0Ljg0IDAgMDAuMDQtLjkxek0xLjQxIDEuNDRoMTIuMjV2MS43MUgxLjQzem0zLjIgNy4zMUgxLjQ0VjVoMTIuMnYyLjk0bC0uMTYtLjE1YTUuOTEgNS45MSAwIDAwLTQtMS42MSA2LjQgNi40IDAgMDAtNC44NyAyLjU3em05LjMgMS41MkE1Ljg0IDUuODQgMCAwMTkuNSAxMi45YTUuODYgNS44NiAwIDAxLTQuNDItMi42M3YtLjEyYy41Ny0uNzkgMi4xNi0yLjYzIDQuNDItMi42M2E1Ljg0IDUuODQgMCAwMTQuNDEgMi42M2wuMDUuMDZ6Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI5LjUiIGN5PSIxMC4yMSIgcj0iMS41NyIvPjwvZz48L2c+PC9zdmc+) bottom/18px 17px no-repeat;
}

.MyOrdersListItem__button--reorder:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOC43NSAxOC43NSI+PGRlZnM+PHN0eWxlPi5jbHMtMntmaWxsOiMyOTdlYzJ9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTEuNzUgMTQuNTdhNS43IDUuNyAwIDAxLTcuODgtNi42OEw0LjY2IDlhLjczLjczIDAgMDAuNjIuMzMuNzQuNzQgMCAwMC42MS0xLjE3TDQuMDYgNS41MmEuNzguNzggMCAwMC0uNDktLjMyLjc1Ljc1IDAgMDAtLjU3LjEyTC4zNCA3LjE2YS43NS43NSAwIDAwLjg1IDEuMjRsMS4yMi0uODRhNy4yMiA3LjIyIDAgMDAxMCA4LjM4Ljc1Ljc1IDAgMDAtLjYyLTEuMzd6TTE4LjYgMTAuNTNhLjc0Ljc0IDAgMDAtMS0uMTlsLTEuMjEuODNhNy4yIDcuMiAwIDAwLTEwLTguMzYuNzYuNzYgMCAwMC0uMzcgMSAuNzUuNzUgMCAwMDEgLjM3IDUuNyA1LjcgMCAwMTcuODkgNi42N2wtLjgtMS4xNWEuNzUuNzUgMCAxMC0xLjIzLjg1bDEuODMgMi42N2EuNzcuNzcgMCAwMDEuMDUuMTlsMi42Ny0xLjg0YS43NS43NSAwIDAwLjE3LTEuMDR6Ii8+PC9nPjwvc3ZnPg==) 50% no-repeat;
}

.MyOrdersListItem__button--reorder:hover:before {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
}

.MyOrdersListItem__button--feedback {
  background: #fff;
  color: #ff5a00;
  border-color: rgba(255, 90, 0, 0.2);
}

.MyOrdersListItem__button--feedback:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC4yIDIwLjg4Ij48ZyBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGRhdGEtbmFtZT0iTGF5ZXIgMSIgZmlsbD0iI2ZmNWEwMCI+PHBhdGggZD0iTTE1LjMyLjFINC44OEE0Ljc4IDQuNzggMCAwMC4xIDQuODh2Ny4wNWE0LjgyIDQuODIgMCAwMDQuNTEgNC43OHYzLjU2YS40Ni40NiAwIDAwLjI3LjQ0LjU2LjU2IDAgMDAuMjQuMDcuNi42IDAgMDAuMy0uMWw1LjE1LTRoNC43NWE0Ljc4IDQuNzggMCAwMDQuNzgtNC43OHYtN0E0Ljc4IDQuNzggMCAwMDE1LjMyLjF6bTMuNzYgMTEuODNhMy43NyAzLjc3IDAgMDEtMy43NiAzLjc2aC00LjkxYS41Mi41MiAwIDAwLS4zMS4xbC00LjQ3IDMuNDZWMTYuMmEuNTMuNTMgMCAwMC0uNTEtLjUxaC0uMjRhMy43NyAzLjc3IDAgMDEtMy43Ni0zLjc2di03YTMuNzcgMy43NyAwIDAxMy43Ni0zLjgxaDEwLjQ0YTMuNzcgMy43NyAwIDAxMy43NiAzLjc2eiIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iLjIiLz48cGF0aCBkPSJNMTEuNDYgNi42MkwxMC4xIDMuOSA4Ljc0IDYuNjJsLTMgLjQ0TDcuOSA5LjE4bC0uNDggMyAyLjY4LTEuNCAyLjY4IDEuNC0uNDgtMyAyLjE2LTIuMTItMy0uNDR6Ii8+PC9nPjwvZz48L3N2Zz4=) 50%/17px 18px no-repeat;
}

.MyOrdersListItem__button--feedback:hover {
  background: #ff5a00;
  border-color: rgba(255, 90, 0, 0.4);
  color: #fff;
}

.MyOrdersListItem__button--feedback:hover:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC4yIDIwLjg4Ij48ZyBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGRhdGEtbmFtZT0iTGF5ZXIgMSIgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTE1LjMyLjFINC44OEE0Ljc4IDQuNzggMCAwMC4xIDQuODh2Ny4wNWE0LjgyIDQuODIgMCAwMDQuNTEgNC43OHYzLjU2YS40Ni40NiAwIDAwLjI3LjQ0LjU2LjU2IDAgMDAuMjQuMDcuNi42IDAgMDAuMy0uMWw1LjE1LTRoNC43NWE0Ljc4IDQuNzggMCAwMDQuNzgtNC43OHYtN0E0Ljc4IDQuNzggMCAwMDE1LjMyLjF6bTMuNzYgMTEuODNhMy43NyAzLjc3IDAgMDEtMy43NiAzLjc2aC00LjkxYS41Mi41MiAwIDAwLS4zMS4xbC00LjQ3IDMuNDZWMTYuMmEuNTMuNTMgMCAwMC0uNTEtLjUxaC0uMjRhMy43NyAzLjc3IDAgMDEtMy43Ni0zLjc2di03YTMuNzcgMy43NyAwIDAxMy43Ni0zLjgxaDEwLjQ0YTMuNzcgMy43NyAwIDAxMy43NiAzLjc2eiIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iLjIiLz48cGF0aCBkPSJNMTEuNDYgNi42MkwxMC4xIDMuOSA4Ljc0IDYuNjJsLTMgLjQ0TDcuOSA5LjE4bC0uNDggMyAyLjY4LTEuNCAyLjY4IDEuNC0uNDgtMyAyLjE2LTIuMTItMy0uNDR6Ii8+PC9nPjwvZz48L3N2Zz4=) 50%/17px 18px no-repeat;
}

.MyOrdersListItem__button--tips {
  min-height: 32px;
  color: #bb812a;
  border-color: rgba(187, 129, 42, 0.5);
  background-color: #fffcf8;
}

.MyOrdersListItem__button--tips:not([aria-disabled]):focus {
  box-shadow: 0 0 0 4px rgba(112, 198, 255, 0.15);
  border-color: #94c9f4;
}

.MyOrdersListItem__button--tips:not([aria-disabled]):active {
  box-shadow: 0 0 0 4px rgba(112, 198, 255, 0.15), inset 0 0 0 1px rgba(112, 198, 255, 0.5);
  border-color: #dce0ef;
  color: #bb812a;
}

.MyOrdersListItem__button--tips:not([aria-disabled]):hover {
  color: #bb812a;
  border-color: #dce0ef;
  background-color: #fff;
}

.MyOrdersListItem__button--tips:before {
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4wMDMiIGhlaWdodD0iMTYuMDAzIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojYmI4MTJhfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNOCAwYTggOCAwIDEwOCA4IDggOCAwIDAwLTgtOHptMCAxNC43NTNBNi43NTEgNi43NTEgMCAxMTE0Ljc1MyA4IDYuNzQ4IDYuNzQ4IDAgMDE4IDE0Ljc1M3oiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTguNzgzIDcuMzc2SDcuMjJhMS4wOTQgMS4wOTQgMCAwMTAtMi4xODhoMy4yODJhLjYyNS42MjUgMCAxMDAtMS4yNUg4LjYyN1YzYS42MjUuNjI1IDAgMTAtMS4yNSAwdi45MzhoLS4xNTZhMi4zNDQgMi4zNDQgMCAwMDAgNC42ODloMS41NjNhMS4wOTQgMS4wOTQgMCAxMTAgMi4xODhINS41MDJhLjYyNS42MjUgMCAxMDAgMS4yNWgxLjg3NHYuOTM4YS42MjUuNjI1IDAgMTAxLjI1IDB2LS45MzdoLjE1NmEyLjM0NCAyLjM0NCAwIDEwMC00LjY4OXoiLz48L3N2Zz4=) 50%/16px 16px no-repeat;
}

@-webkit-keyframes inprogress {
  0% {
    background-position: 32px 0;
  }
  to {
    background-position: 0 0;
  }
}

@keyframes inprogress {
  0% {
    background-position: 32px 0;
  }
  to {
    background-position: 0 0;
  }
}

.OrdersList {
  margin: 0 0 20px;
}

.OrdersList__title {
  color: #646e7a;
  font-size: 19px;
  font-weight: 600;
  margin: 0 0 15px;
  text-transform: uppercase;
}

.OrdersList__empty-message {
  color: #777;
  font-size: 14px;
  font-weight: 700;
  padding: 40px 20px;
  text-align: center;
  text-transform: uppercase;
}

.OrdersList__empty-message:before {
  background: transparent url(data:image/svg+xml;base64,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) 50% / contain no-repeat;
  content: "";
  display: block;
  height: 160px;
  margin: 0 auto;
  width: 220px;
}

.OrdersList__empty-message__text {
  margin-bottom: 18px;
}

.OrdersList__more {
  display: block;
  margin: 20px auto;
}

.progress-segments {
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 0 2px #fff;
  display: flex;
  font-size: 12px;
}

@media only screen and (min-width: 641px) {
  .progress-segments:not(.single) {
    width: 100%;
  }
}

.progress-segments .segment {
  color: #898989;
  flex: 1 0;
  line-height: 26px;
  margin-right: 2px;
  padding: 0 14px;
  position: relative;
  text-align: center;
  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);
  white-space: nowrap;
  z-index: 1;
}

@media only screen and (max-width: 640px) {
  .progress-segments .segment:not(.active) {
    display: none;
  }
}

.progress-segments .segment:after,
.progress-segments .segment:before {
  background-color: #e1e8e4;
  box-sizing: border-box;
  content: " ";
  display: block;
  height: 50%;
  left: 0;
  position: absolute;
  right: 0;
  z-index: -1;
}

.progress-segments .segment:before {
  top: 0;
  -webkit-transform: skewX(30deg);
  transform: skewX(30deg);
}

.progress-segments .segment:after {
  bottom: 0;
  -webkit-transform: skewX(-30deg);
  transform: skewX(-30deg);
}

.progress-segments .segment:last-child:after,
.progress-segments .segment:last-child:before {
  border-right-width: 0;
}

.progress-segments .segment.active {
  font-weight: 700;
}

.progress-segments .segment.active.order-pay-segment {
  color: #ac7d00;
}

.progress-segments .segment.active.order-pay-segment:after,
.progress-segments .segment.active.order-pay-segment:before {
  background-color: #f2eec3;
}

.progress-segments .segment.active.order-assign-segment {
  color: #0e8b90;
}

.progress-segments .segment.active.order-assign-segment:after,
.progress-segments .segment.active.order-assign-segment:before {
  background-color: #d1f3f4;
}

.progress-segments .segment.active.order-progress-segment {
  color: #156384;
}

.progress-segments .segment.active.order-progress-segment:after,
.progress-segments .segment.active.order-progress-segment:before {
  background-color: rgba(196, 233, 246, 0.97);
}

.progress-segments .segment.active.order-review-segment {
  color: #75189c;
}

.progress-segments .segment.active.order-review-segment:after,
.progress-segments .segment.active.order-review-segment:before {
  background-color: #decdf2;
}

.progress-segments .segment.active.order-review-segment.in-review {
  color: #8a028c;
}

.progress-segments .segment.active.order-review-segment.in-review:after,
.progress-segments .segment.active.order-review-segment.in-review:before {
  background-color: rgba(238, 189, 240, 0.97);
}

.progress-segments .segment.active.order-approve-segment {
  color: #a97000;
}

.progress-segments .segment.active.order-approve-segment:after,
.progress-segments .segment.active.order-approve-segment:before {
  background-color: #fbd4a5;
}

.progress-segments .segment.active.order-approve-segment.dispute {
  color: #a73300;
}

.progress-segments .segment.active.order-approve-segment.dispute:after,
.progress-segments .segment.active.order-approve-segment.dispute:before {
  background-color: rgba(251, 199, 178, 0.97);
}

.progress-segments .segment.order-cancelled-segment {
  color: #cf4545;
  font-weight: 700;
}

.progress-segments .segment.order-cancelled-segment:after,
.progress-segments .segment.order-cancelled-segment:before {
  background-color: #f3f3f3;
}

.progress-segments .segment.order-finished-segment {
  color: #3ba038;
  font-weight: 700;
}

.progress-segments .segment.order-finished-segment:after,
.progress-segments .segment.order-finished-segment:before {
  background-color: #f3f3f3;
}

.progress-segments .segment.order-cancelled-segment,
.progress-segments .segment.order-finished-segment {
  -webkit-perspective: 70px;
  perspective: 70px;
}

.progress-segments .segment.order-cancelled-segment:after,
.progress-segments .segment.order-cancelled-segment:before,
.progress-segments .segment.order-finished-segment:after,
.progress-segments .segment.order-finished-segment:before {
  left: -3px;
  right: -3px;
}

.progress-segments .segment.order-cancelled-segment:before,
.progress-segments .segment.order-finished-segment:before {
  -webkit-transform: rotateX(-45deg) scaleY(3);
  transform: rotateX(-45deg) scaleY(3);
  -webkit-transform-origin: top;
  transform-origin: top;
}

.progress-segments .segment.order-cancelled-segment:after,
.progress-segments .segment.order-finished-segment:after {
  -webkit-transform: rotateX(45deg) scaleY(3);
  transform: rotateX(45deg) scaleY(3);
  -webkit-transform-origin: bottom;
  transform-origin: bottom;
}

.progress-segments.single {
  display: inline-block;
}

</style>
